// src/pages/UserProfile.jsx
import React, { useEffect, useState } from "react";
import axios from "../api/axios"; // your axios instance
import { Link, useNavigate } from "react-router-dom";

export default function UserProfile() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await axios.get("/user");
        // Check if user is admin — if yes, redirect
        if (res.data.role && res.data.role.toLowerCase() === "admin") {
          navigate("/"); // send admins away
          return;
        }
        setUser(res.data);
      } catch (error) {
        console.error("Error fetching user profile:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchUser();
  }, [navigate]);

const handleLogout = async () => {
  const confirmLogout = window.confirm("Are you sure you want to logout?");
  if (!confirmLogout) return; // ❌ stop if user clicks cancel

  try {
    await axios.post("/logout");
    localStorage.removeItem("token");
    window.location.reload();
  } catch (error) {
    console.error("Error logging out:", error);
  }
};


  if (loading) {
    return <div className="container mt-5">Loading profile...</div>;
  }

  if (!user) {
    return (
      <div className="container mt-5">
        <h3>You need to log in to view your profile.</h3>
        <Link to="/login" className="btn btn-primary mt-3">
          Go to Login
        </Link>
      </div>
    );
  }

  return (
    <div className="container mt-5">
      <div className="card shadow-sm">
        <div className="card-body">
          {/* <div className="text-center">
            <img
              src={user.avatar_url || "/default-avatar.png"}
              alt="User Avatar"
              className="rounded-circle mb-3"
              style={{ width: "100px", height: "100px", objectFit: "cover" }}
            />
            <h3>{user.name}</h3>
            <p className="text-muted">{user.email}</p>
          </div> */}

          <hr />

          <h5>Account Details</h5>
          <ul className="list-unstyled">
            <li>
              <strong>Username:</strong> {user.email}
            </li>
            <li>
              <strong>Name:</strong> {user.name || "Not provided"}
            </li>
            <li>
              <strong>Email:</strong> {user.email || "Not provided"}
            </li>
            <li>
              <strong>Joined:</strong>{" "}
              {new Date(user.created_at).toLocaleDateString()}
            </li>
          </ul>

          <div className="mt-4">
            <Link to="/profile/edit" className="btn btn-outline-primary me-2">
              Edit Profile
            </Link>
            <Link to="/orders" className="btn btn-outline-success me-2">
              My Orders
            </Link>
            <Link to="#" onClick={handleLogout} className="btn btn-outline-info">
              Logout
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
